import { PureComponent } from 'react';

import { ComponentLinkProxy } from 'src/components/component-link';
import { ExpandablePath } from 'src/components/path';

import { CurrentEntryPathSegment, LinkedPathSegment } from './path.style';

export type Props = {
  buildPathSegmentUrl: (path: string) => string;
  path: string;
  repositorySlug: string;
};

export default class FilePath extends PureComponent<Props> {
  render() {
    const { buildPathSegmentUrl, path, repositorySlug } = this.props;

    const splitPath = path.split('/');
    const pathSegments = [repositorySlug, ...splitPath.slice(0, -1)];
    const wrappedSegments = pathSegments.map((segment, i) => {
      const segmentPath = i === 0 ? '' : `${splitPath.slice(0, i).join('/')}/`;

      return (
        <LinkedPathSegment key={`segment-${segmentPath}`}>
          <ComponentLinkProxy href={buildPathSegmentUrl(segmentPath)}>
            {segment}
          </ComponentLinkProxy>
        </LinkedPathSegment>
      );
    });

    const currentSegment = (
      <CurrentEntryPathSegment key="segment-current">
        {splitPath.pop()}
      </CurrentEntryPathSegment>
    );

    return (
      <ExpandablePath>{[...wrappedSegments, currentSegment]}</ExpandablePath>
    );
  }
}
